import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import Loader from '../../components/Loader/Loader';
import HeaderService from '../../services/HeaderService/HeaderService';
import UserService from '../../services/UserService/UserService';
import './Modal.css';

const SelectViewAs = ({ isShow, onClose }) => {
    const [isShowLoader, setIsShowLoader] = useState(false);
    const [isShowGearSpinner, setIsShowGearSpinner] = useState(false);
    const [selectedViewAs, setSelectedViewAs] = useState(() => {
        const stored = localStorage.getItem('techtop_selected_view_as');
        return stored ? JSON.parse(stored) : null;
    });
    const [menuItems, setMenuItems] = useState([]);
    const [loaderMessage, setLoaderMessage] = useState("Please wait...");
    const hasSelectedView = !!localStorage.getItem('techtop_selected_view_as');

    const headerServices = new HeaderService();
    const userServices = new UserService();

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            textAlign: "center",
            cursor: "pointer",
        }),

        singleValue: (provided) => ({
            ...provided,
            textAlign: "center",
            width: "100%",
        }),

        placeholder: (provided) => ({
            ...provided,
            textAlign: "center",
            width: "100%",
        }),
    };

    const handleSelectViewAs = (selectedOption) => {
        setSelectedViewAs(selectedOption);
    };

    useEffect(() => {
        if (isShow) {
            setIsShowGearSpinner(true); // Reset loader when modal opens
            const stored = localStorage.getItem('techtop_selected_view_as');
            setSelectedViewAs(stored ? JSON.parse(stored) : null);
            getUsersList();
        }
    }, [isShow]);

    const getUsersList = async () => {
        const user_email = localStorage.getItem('techtop_user_email');
        const data = {
            user_email: user_email
        }
        const response = await headerServices.getCompanyList(data);
        console.log(response);
        if (response.data.status == 'success') {
            const companies = response.data.result;
            const userOptions = companies.map(company => ({
                value: company.id,
                label: company.company
            }));
            setMenuItems(userOptions);
        }
        setIsShowGearSpinner(false);
    }

    const handleSetViewAs = async () => {
        onClose();
        setIsShowLoader(true);
        setLoaderMessage(`Setting view as ${selectedViewAs.label}...`);
        const status = await setUserView(selectedViewAs.value);
        if (status) {
            localStorage.setItem('techtop_selected_view_as', JSON.stringify(selectedViewAs));
            window.location.reload();
        } else {
            onClose();
        }
        setIsShowLoader(false);
    }

    const setUserView = async (user_view_id) => {
        const user_email = localStorage.getItem('techtop_user_email');
        const data = {
            user_email: user_email,
            user_view_id: user_view_id
        }
        const response = await userServices.setUserView(data);
        console.log(response);
        if (response.data.status == 'success') {
            localStorage.setItem('techtop_user_company', response.data.result.company);
            localStorage.setItem('techtop_user_company_logo', response.data.result.company_logo);
            localStorage.setItem('techtop_user_multiplier', JSON.stringify(response.data.result.multiplier));
            return true;
        } else {
            return false;
        }
    }

    const handleResetViewAs = async () => {
        setSelectedViewAs(null);
        onClose();
        setLoaderMessage("Resetting view to your profile...");
        setIsShowLoader(true);
        const user_id = localStorage.getItem('techtop_user_id');
        const status = await setUserView(user_id);
        if (status) {
            localStorage.removeItem('techtop_selected_view_as');
            window.location.reload();
        } else {
            onClose();
        }
        setIsShowLoader(false);
    };

    return (
        <React.Fragment>
            <div className={`modal fade modal-overlay ${isShow ? 'show' : ''}`} id="viewasModal" tabIndex="-1" aria-labelledby="viewasModalLabel" aria-hidden="true" style={{ display: `${isShow ? 'block' : 'none'}` }}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <div className='w-100 text-center'>
                                <h4>View as</h4>
                            </div>
                            {isShowGearSpinner && <GearSpinner />}
                            {!isShowGearSpinner && menuItems && Object.keys(menuItems).length > 0 && (
                                <React.Fragment>
                                    <div className='d-flex w-100 justify-content-between gap-2 mt-3'>
                                        <div className='w-75'>
                                            <Select
                                                options={menuItems}
                                                onChange={handleSelectViewAs}
                                                className="w-100"
                                                value={selectedViewAs}
                                                isClearable={true}
                                                isSearchable={true}
                                                styles={customStyles}
                                            />
                                        </div>
                                        <div className="w-25">
                                            <button
                                                type="button"
                                                className={`btn btn-light w-100 m-0 rounded ${!hasSelectedView ? 'disabled' : ''}`}
                                                disabled={!hasSelectedView}
                                                onClick={handleResetViewAs}
                                            >
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                    <div className='d-flex w-100 justify-content-evenly gap-4 mt-3'>
                                        <button
                                            type="button"
                                            className="btn btn-secondary w-50 m-0 rounded"
                                            onClick={onClose}>
                                            Close
                                        </button>
                                        <button
                                            type="button"
                                            className={`submit-button w-50 m-0 rounded submit-error-report ${!selectedViewAs ? 'disabled' : ''}`}
                                            disabled={!selectedViewAs ? true : false}
                                            onClick={handleSetViewAs}>
                                            Set
                                        </button>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Loader message={loaderMessage} isLoading={isShowLoader} />
        </React.Fragment>
    );
};

export default SelectViewAs;
